<template>
  <v-dialog v-model="showShareDialog" id="buckets-share-dialog" width="100%" max-width="1200px">
    <v-card class="pa-4">
      <p>
        Add a team or an individual to this bucket.
        <strong>Note:</strong> You can click a team icon to view all members in a team.
      </p>

      <!-- BUCKET SHARE -->
      <ParticipantsPanel
        :available-users="availableUsers"
        :available-teams="availableTeams"
        :participating-users="participatingUsers"
        :participating-teams="participatingTeams"
        v-on:pending-update="updateData">
      </ParticipantsPanel>

      <v-card-actions class="ma-0 pa-0">
        <v-btn color="success" @click="saveChanges">Save changes</v-btn>
        <v-btn
          @click="$emit('share-dialog-closed')"
          color="error"
          id="bucket-share-dialog-cancel-btn"
        >Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ParticipantsPanel from "@/components/ParticipantsPanel.vue"
export default {
  name: "bucket-share",
  props: {
    showShareDialog: Boolean,
    participatingTeams: Array,
    participatingUsers: Array,
    availableTeams: Array,
    availableUsers: Array
  },
  components: { ParticipantsPanel },
  data: () => ({
    pendingAddUsers: [],
    pendingAddTeams: [],
    pendingRemoveUsers: [],
    pendingRemoveTeams: []
  }),
  computed: {
    bucketId() { return parseInt(this.$route.params.bucket_id) }
  },
  methods: {
    updateData(data) {
      this.pendingAddUsers = data.pendingAddUsers
      this.pendingRemoveUsers = data.pendingRemoveUsers
      this.pendingAddTeams = data.pendingAddTeams
      this.pendingRemoveTeams = data.pendingRemoveTeams
    },
    saveChanges() {
      this.$store.dispatch("addParticipantsToBucket", {
        participants: this.pendingAddUsers,
        type: "user",
        bucketId: this.bucketId
      })
      this.$store.dispatch("addParticipantsToBucket", {
        participants: this.pendingAddTeams,
        type: "team",
        bucketId: this.bucketId
      })
      this.$store.dispatch("removeParticipantsToBucket", {
        participants: this.pendingRemoveUsers,
        type: "user",
        bucketId: this.bucketId
      })
      this.$store.dispatch("removeParticipantsToBucket", {
        participants: this.pendingRemoveTeams,
        type: "team",
        bucketId: this.bucketId
      })
      this.pendingAddUsers = []
      this.pendingAddTeams = []
      this.pendingRemoveUsers = []
      this.pendingRemoveTeams = []
      this.$emit("share-dialog-closed")
    }
  }
}
</script>
